export const isAuthenticatedGuardStart = async (to: any, from: any, next: any) => {
  if ( window.sessionStorage.getItem("isAuthenticated") === "1" && window.sessionStorage.getItem("user")) {
    next({ name: "dashboard" });
  } else {
    next();
  }
};

export default { isAuthenticatedGuardStart };
